import { useFetch } from "../../hooks/useFetch";
import { Loading, EmptyState } from "../../components/States";
import { CHead, Pill } from "../../components/customer/ui";
import { CATEGORY_PHOTOS } from "../../lib/photos";
import { useNavigate } from "react-router-dom";
import { Wrench, MapPin, ArrowRight } from "lucide-react";

function pct(j) {
  if (typeof j.percent === "number") return j.percent;
  if (Array.isArray(j.progress) && j.progress.length) return Math.round((j.progress.filter((s) => s.done).length / j.progress.length) * 100);
  return j.status === "complete" ? 100 : j.status === "in_progress" ? 50 : 10;
}
function thumb(j) {
  return j.image || CATEGORY_PHOTOS[j.category_id] || CATEGORY_PHOTOS.residential_repairs;
}

export default function CustomerProjects() {
  const { data, loading } = useFetch("/jobs");
  const navigate = useNavigate();
  if (loading) return <Loading />;
  const jobs = data || [];

  return (
    <div className="space-y-6">
      <CHead title="My Projects" subtitle="Track every job from estimate to completion." />
      {jobs.length === 0 ? (
        <EmptyState title="No projects yet" subtitle="Approved work will appear here." icon={Wrench} />
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {jobs.map((j) => (
            <button key={j.id} onClick={() => navigate(`/portal/projects/${j.id}`)} className="group overflow-hidden rounded-2xl border border-slate-200 bg-white text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md" data-testid={`project-card-${j.id}`}>
              <div className="relative h-44 overflow-hidden bg-slate-100">
                <img src={thumb(j)} alt={j.image ? `${j.title} — supplied project image` : `${j.title} — service category image`} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                <div className="absolute right-3 top-3"><Pill status={j.status} /></div>
              </div>
              <div className="p-5">
                <div className="text-lg font-bold text-slate-900">{j.title}</div>
                <div className="mt-1.5 flex items-center gap-2 text-sm text-slate-500"><MapPin size={14} /> {j.address}</div>
                <div className="mt-4">
                  <div className="mb-1 flex items-center justify-between text-xs font-semibold text-slate-500"><span>Progress</span><span>{pct(j)}%</span></div>
                  <div className="h-2 overflow-hidden rounded-full bg-slate-200"><div className="h-full rounded-full bg-[#1286F2] transition-all" style={{ width: `${pct(j)}%` }} /></div>
                </div>
                <div className="mt-4 flex items-center gap-1 text-sm font-semibold text-[#1286F2]">View Project <ArrowRight size={15} /></div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
